export default {
  viewType: 'form',
  module: '/system/spec/edit',
  params: {},
  okAction: 'OkAction',
  callBackAction: 'OkActionCb',
  toolbar: {
    items: [
      {
        slot: 'left',
        label: '确定',
        props: {
          type: 'primary'
        },
        action: 'OkAction'
      }
    ]
  },
  needFetchFillInfo: true,
  fillDetailUrl: `/system/spec/edit/state`,
  view: {
    showOkBtn: false,
    labelPosition: 'right',
    labelWidth: '225px',
    content: [
      {
        $id: 'maintenanceState',
        $type: 'switch',
        label: '维护模式开关'
      },
      {
        $id: 'maintenanceTime',
        $type: 'datePicker',
        $el: {
          type: 'datetime',
          pickerOptions: {
            disabledDate(date) {
              const now = new Date()
              now.setDate(now.getDate() - 1)
              return date.getTime() < now.getTime()
            }
          }
        },
        label: '维护模式结束时间',
        rules: [
          {
            notEmpty: '维护模式结束时间'
          }
        ]
      }
    ]
  }
}
